import { HttpError } from "react-admin";
import { StatusCodes } from "http-status-codes";
import { VARS } from "shared/constants/vars";

export const isForbiddenError = function (error: any)  {
  return error instanceof HttpError && error.status === StatusCodes.FORBIDDEN;
};

export const isValidationError = function (error: any)  {
  return error instanceof HttpError && error.message === VARS.validationErrorMessage;
};
